import React, { useEffect, useRef, useState } from "react";
import { RaceDTO } from "../../interfaces/RaceDTO";
import { Dropdown } from "react-bootstrap";
import "./teamstyle.css";
import { AthleteDTO } from "../../interfaces/AthletesDTO";
import TeamBox from "./TeamBox";
import { eventBus } from "../../services/eventHandler";

interface Props {
  race: RaceDTO;
}

const Team = ({ race }: Props) => {
  const [teams, setTeams] = useState<string[] | null>(null);
  const [selectedTeam, setSelectedTeam] = useState<string | null>(null);
  const [athletes, setAthletes] = useState<teamresults | null>(null);
  const selectedTeamref = useRef<string | null>();
  useEffect(() => {
    let tea: string[] = [];
    for (let key in race.Class) {
      let athl = race.Class[key].Level[1].Athletes;
      for (let k in athl) {
        tea.push(athl[k].Club);
      }
    }
    let distinctTea: string[] = Array.from(new Set(tea)).sort();
    setTeams(distinctTea);
    let lastTeam = localStorage.getItem("seletced_team")
    if (lastTeam){
      if (distinctTea.includes(lastTeam)){
        setSelectedTeam(lastTeam);
      }
    }
    const handler = (ath: AthleteDTO | null) => {
      if (ath !== null) {
        if (ath.Club !== selectedTeamref.current){
          setSelectedTeam(ath.Club);
        }
      }

      // console.log(race.Sport);
    };
    
    eventBus.on(`selctedathlete`, handler);
    return () => {
      // Cleanup to avoid memory leaks
        eventBus.removeListener(`selctedathlete`, handler);
    };

  }, []);

  useEffect(() => {
    let aths: teamresults = {
      athletes: {},
    };
    for (let key in race.Class) {
      let ath: AthleteDTO[] = Object.values(
        race.Class[key].Level[1].Athletes
      ).filter((o) => o.Club === selectedTeam);
      if (ath.length > 0) {
        aths.athletes[race.Class[key].Name] = ath;

      }
    }
    setAthletes(aths);
    if (selectedTeam)
    localStorage.setItem("seletced_team",selectedTeam)

    selectedTeamref.current = selectedTeam;
  }, [selectedTeam]);

  if (teams === null) {
    return <div> team null</div>;
  }

  return (
    <div className="team-box">
      <div className="team-hader">
        <Dropdown>
          <Dropdown.Toggle
            variant="secondary"
            id="dropdown-basic"
            className="btn- btn-light"
            style={{ height: "31px", paddingTop: "4px" }}
          >
            {selectedTeam ? selectedTeam : "Choose team"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {teams.map((te, ind) => {
              return (
                <Dropdown.Item key={ind} onClick={() => setSelectedTeam(te)}>
                  {te}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="team-data-box">
      {/* <button
             
            >
              Add Favorites
            </button> */}
        {athletes ? (
          Object.keys(athletes.athletes).map((key,ind) => {
            return (
              <TeamBox key={ind} athletes={athletes.athletes[key]} classname={key} />
            );
          })
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Team;

export interface teamresults {
  athletes: { [key: string]: AthleteDTO[] };
}
